import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1>Privacy Policy for rawgr.com</h1>
      <p>
        <strong>Effective Date:</strong> February 25, 2025
      </p>

      <p>
        At rawgr.com ("we," "us," or "our"), we consider the privacy and
        security of personal data to be extremely important. This Privacy Policy
        describes how we collect, use, and share personal data of:
      </p>
      <ul>
        <li>Our website users</li>
        <li>Newsletter subscribers</li>
        <li>Potential customers</li>
        <li>Our counterparties and their representatives</li>
      </ul>

      <p>
        This policy applies to information collected on our website, rawgr.com
        (the "Site"), and other sources.
      </p>

      <p>
        If you have any questions or suggestions concerning our privacy
        practices, please email us at{" "}
        kaundiverse@gmail.com{" "}
        also send us an email if you would like to request data access or
        deletion, or to exercise other rights as a data subject.
      </p>

      <h2>Table of Contents:</h2>
      <ul>
        <li>How We Collect Personal Data</li>
        <li>What Types of Personal Data We Process</li>
        <li>For Which Purposes We Use Personal Data</li>
        <li>How We Share Personal Data</li>
        <li>Your Data Protection Rights & Choices</li>
        <li>For How Long We Retain Personal Data</li>
        <li>International Data Transfers</li>
        <li>Children's Information</li>
        <li>Security</li>
        <li>
          Legal Basis for Processing Your Personal Data (EEA Visitors/Customers
          Only)
        </li>
        <li>For California Residents</li>
        <li>Changes to Our Privacy Policy</li>
        <li>How to Contact Us</li>
      </ul>

      <h2>1. How We Collect Personal Data</h2>
      <p>
        What personal data we collect depends largely on your interaction with
        rawgr.com:
      </p>
      <ul>
        <li>
          When you send us emails or message us, we store the content of such
          emails and your contact details.
        </li>
        <li>
          When you submit forms or participate in our events, we collect the
          information provided.
        </li>
        <li>
          When you use the Site, we collect data such as cookies and metadata.
        </li>
        <li>
          When you join our communities, we have access to public information
          you share.
        </li>
      </ul>

      <h2>2. What Types of Personal Data We Process</h2>
      <ul>
        <li>Contact details and business data</li>
        <li>Requests, messages, and submitted forms details</li>
        <li>Usage data, logs, and other technical data</li>
        <li>Email performance data</li>
        <li>Website cookies and similar technologies</li>
      </ul>

      <h2>3. For Which Purposes We Use Personal Data</h2>
      <ul>
        <li>To communicate with you and provide updates</li>
        <li>To conduct events and send reminders</li>
        <li>To comply with applicable laws</li>
        <li>To negotiate and enter agreements</li>
        <li>For compliance and safety purposes</li>
      </ul>

      <h2>4. How We Share Personal Data</h2>
      <p>We do not sell your data. We may share it with:</p>
      <ul>
        <li>Service providers (e.g., cloud storage, email agents)</li>
        <li>Professional advisors (e.g., lawyers, auditors)</li>
        <li>Business transfers in case of mergers or acquisitions</li>
        <li>Legal authorities when required by law</li>
        <li>Corporate affiliates</li>
      </ul>

      <h2>5. Your Data Protection Rights & Choices</h2>
      <p>You have the following rights:</p>
      <ul>
        <li>
          If you wish to access your personal data that rawgr.com collects, you
          can do so at any time by contacting us.
        </li>
        <li>
          You can also contact us to update, correct, or delete information in
          your account.
        </li>
        <li>
          If you are in the European Economic Area (“EEA”), the UK, or
          Switzerland, you can object to the processing of your personal data,
          ask us to restrict the processing of your personal data, or request
          the portability of your personal data where it is technically
          possible.
        </li>
        <li>
          Similarly, if you are in the EEA, the UK, or Switzerland, and provided
          we have collected and processed your personal data under your consent,
          then you can withdraw your consent at any time. Withdrawing your
          consent will not affect the lawfulness of any processing we conducted
          prior to your withdrawal, nor will it affect the processing of your
          personal data conducted in reliance on other lawful processing
          grounds.
        </li>
        <li>
          You have the right to complain to a data protection authority about
          our collection and use of your personal data. Contact details for data
          protection authorities in the EEA, Switzerland, and certain
          non-European countries (including the U.S. and Canada) are available {" "}
          <a href="https://ec.europa.eu/justice/article-29/structure/data-protection-authorities/index_en.htm">
             here
          </a>
          .
        </li>
      </ul>
      <p>
        You may submit your request by sending an email to
        kaundiverse@gmail.com. We will respond to all requests in accordance
        with applicable data protection laws.
      </p>

      <h2>6. For How Long We Retain Personal Data</h2>
      <p>
        We will retain and process personal data for the period necessary to
        fulfill the purposes outlined in this Privacy Policy unless a longer
        retention period is required or permitted by law.
      </p>
      <p>
        We may also store some data during a retention period required by law or
        a timeframe necessary to resolve disputes, prevent abuse, and enforce
        our agreements.
      </p>

      <h2>7. International Data Transfers</h2>
      <p>
        Your personal data may be stored and processed in any country where we
        have facilities or in which we engage service providers, including in
        the U.S.
      </p>
      <p>
        By using the Site, you acknowledge and agree to (1) the transfer to and
        processing of personal data on servers located outside of the country
        where you reside and (2) our collection and use of your personal data as
        described herein and in accordance with the data protection laws of the
        countries in which we have facilities or in which we engage service
        providers, which may be different and may be less protective than the
        laws in your country. We are committed to protecting the privacy of your
        information, no matter where it's processed.
      </p>

      <h2>8. Children's Information</h2>
      <p>
        The Site is not directed to children under the age of 16, and we do not
        knowingly collect personal data from children under the age of 16. If we
        learn that we have collected personal data from a child under the age of
        16, we will take steps to delete the information as soon as possible.
      </p>

      <h2>9. Security</h2>
      <p>
        We take reasonable measures to protect the personal data we collect from
        loss, theft, misuse, and unauthorized access, disclosure, alteration,
        and destruction. However, no method of transmission over the Internet or
        method of electronic storage is perfectly secure. Therefore, while we
        strive to use commercially acceptable means to protect your personal
        data, we cannot guarantee its absolute security.
      </p>

      <h2>
        10. Legal Basis for Processing Your Personal Data (EEA
        Visitors/Customers Only)
      </h2>
      <p>
        If you are a visitor from the European Economic Area (EEA), our legal
        basis for collecting and using the personal data described in this
        Privacy Policy depends on the personal data we collect and the specific
        context in which we collect it.
      </p>
      <p>We may process your personal data because:</p>
      <ul>
        <li>We need to perform a contract with you.</li>
        <li>You have given us permission to do so.</li>
        <li>
          The processing is in our legitimate interests and not overridden by
          your rights.
        </li>
        <li>To comply with the law.</li>
      </ul>

      <h2>11. For California Residents</h2>
      <p>
        If you are a California resident, you have certain rights under the
        California Consumer Privacy Act (CCPA). Please see our separate
        California Privacy Notice for more information on these rights.
      </p>

      <h2>12. Changes to Our Privacy Policy</h2>
      <p>
        We may change this Privacy Policy from time to time. If we make changes,
        we will notify you by revising the date at the top of this policy and,
        in some cases, we may provide you with additional notice (such as adding
        a statement to our homepage or sending you a notification). We encourage
        you to review our Privacy Policy whenever you access the Site to stay
        informed about our information practices and the ways you can help
        protect your privacy.
      </p>

      <h2>13. How to Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy or our
        privacy practices, please contact us at:
      </p>
      <p>
        <strong>Email:</strong> kaundiverse@gmail.com
      </p>
    </div>
  );
};

export default PrivacyPolicy;
